<template>
  <v-app>
    <v-card width="full-width" style="max-height: 460px" elevation="0">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="2"></v-col>

          <!--Search To Field-->
          <v-col cols="12" sm="7"></v-col>

          <v-col cols="12" sm="2">
            <v-text-field class="pt-0" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-col>
          <!-- To add new Surveys -->
          <v-col cols="12" sm="1">
            <v-btn color="primary" @click="dialog = true" dark>Add</v-btn>
            <v-dialog v-model="dialog" persistent max-width="500px" color="blue">
              <v-card>
                <v-card-title class="secondary">
                  <span class="subtitle-2 white--text">Register Surveyor</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="closeForadd()" class="white--text">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" md="12" lg="12" class="pt-7">
                          <v-text-field
                            label="Full Name*"
                            required
                            :maxlength="max"
                            :rules="[rules.required,rules.namerules]"
                            v-model="surveyorNameAdd"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" lg="6" class="mt-n7">
                          <v-select
                            :items="countryList"
                            item-text="countryWithCC"
                            item-value="dial_cc"
                            :rules="[rules.required]"
                            v-model="countryAdd"
                            label="Country*"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6" lg="6" class="pt-7 mt-n11">
                          <v-text-field
                            label="Mobile Number*"
                            required
                            append-icon="phone_iphone"
                            v-model="mobileNumberAdd"
                            :rules="[rules.required,rules.contactNumber]"
                            :maxlength="max_Num"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6" class="mt-n7">
                          <v-text-field
                            label="Email*"
                            required
                            append-icon="email"
                            v-model="emailAdd"
                            :rules="[rules.required,rules.email]"
                            :maxlength="max"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6" class="mt-n7">
                          <v-select
                            :items="surveyorTypes"
                            v-model="typeAdd"
                            :rules="[rules.required]"
                            item-text="surveyortype_name"
                            item-value="surveyortype_id"
                            label="Type*"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" lg="6" class="mt-n7">
                          <v-text-field
                            label="City*"
                            :rules="[rules.required]"
                            :maxlength="max"
                            required
                            v-model="cityAdd"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6" class="mt-n7">
                          <v-text-field
                            label="State*"
                            :rules="[rules.required,rules.namerules]"
                            :maxlength="max"
                            required
                            v-model="stateAdd"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6" class="mt-n7">
                          <v-text-field
                            label="ZIP*"
                            :maxlength="max_Num"
                            :rules="[rules.required,rules.zipNumber]"
                            v-model="zipAdd"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6" class="mt-n7">
                          <v-select
                            :items="departmentlist"
                            v-model="departmentAdd"
                            :rules="[rules.required]"
                            label="Department*"
                            item-text="departmentname"
                            item-value="departmentid"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-btn
                  class="secondary White--text mt-n10 mb-6"
                  text
                  :loading="loading3"
                  @click="insertNewSurveyor()"
                  id="Register"
                >Register</v-btn>
              </v-card>
            </v-dialog>
            <v-dialog v-model="editdialog" persistent max-width="500px">
              <v-card>
                <v-card-title class="secondary">
                  <span class="subtitle-2 white--text">Edit Surveyor</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="editdialog = false" class="white--text">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                  <v-form ref="form1" v-model="valid1" lazy-validation>
                    <v-row>
                      <v-col cols="12" md="12" lg="12" class="pt-7">
                        <v-text-field
                          label="Full Name*"
                          required
                          v-model="editSurveyorName"
                          :maxlength="max"
                          :rules="[rules.required,rules.namerules]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" class="mt-n7">
                        <v-autocomplete
                          :items="countryList"
                          item-text="countryWithCC"
                          item-value="dial_cc"
                          v-model="editCountry"
                          :rules="[rules.required]"
                          label="Country*"
                          required
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" lg="6" class="pt-7 mt-n11">
                        <v-text-field
                          label="Mobile Number*"
                          required
                          append-icon="phone_iphone"
                          v-model="editPhoneNumber"
                          :rules="[rules.required,rules.contactNumber]"
                          :maxlength="max_Num"
                          hint="Maximum 15 Numbers"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-n7">
                        <v-text-field
                          label="Email*"
                          required
                          append-icon="email"
                          v-model="editEmail"
                          readonly
                          :rules="[rules.required,rules.email]"
                          :maxlength="max"
                          hint="Maximum 30 Character"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-n7">
                        <v-select
                          :items="surveyorTypes"
                          :rules="[rules.required]"
                          v-model="editType"
                          item-text="surveyortype_name"
                          item-value="surveyortype_id"
                          label="Type*"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-n7">
                        <v-text-field
                          label="City*"
                          :rules="[rules.required]"
                          hint="Maximum 30 Character"
                          :maxlength="max"
                          required
                          v-model="editCity"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-n7">
                        <v-text-field
                          label="State*"
                          :rules="[rules.required,rules.namerules]"
                          hint="Maximum 30 Character"
                          :maxlength="max"
                          required
                          v-model="editState"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-n7">
                        <v-text-field
                          label="ZIP*"
                          :rules="[rules.required,rules.zipNumber]"
                          :maxlength="max_Num"
                          hint="Maximum 15 Numbers"
                          v-model="editZIP"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" class="mt-n7">
                        <v-select
                          :items="departmentlist"
                          v-model="editDepartment"
                          label="Department*"
                          :rules="[rules.required]"
                          item-text="departmentname"
                          item-value="departmentid"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-btn
                  class="secondary White--text mt-n5 mb-6"
                  text
                  :loading="loading4"
                  @click="surveyorUpdate"
                  id="Register"
                >Update</v-btn>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-content>
      <v-data-table
        :headers="headers"
        :items="surveyorTableData"
        :items-per-page="10"
        :loading="tableLoading"
        :disable="tableLoading"
        class="elevation-10"
        :search="search"
      >
        <template v-slot:item.surveyor_createdon="{ item }">
          <span class="caption">{{ item.surveyor_createdon }}</span>
        </template>
        <template v-slot:item.serveyorname="{ item }">
          <span class="caption">{{ item.serveyorname }}</span>
        </template>
        <template v-slot:item.mobno="{ item }">
          <span class="caption">{{ item.mobno }}</span>
        </template>
        <template v-slot:item.serveyoremail="{ item }">
          <span class="caption">{{ item.serveyoremail }}</span>
        </template>
        <template v-slot:item.surveyor_type="{ item }">
          <span class="caption">{{ item.surveyor_type }}</span>
        </template>
        <template v-slot:item.surveyorcity="{ item }">
          <span class="caption">{{ item.surveyorcity }}</span>
        </template>
        <template v-slot:item.surveyorstate="{ item }">
          <span class="caption">{{ item.surveyorstate }}</span>
        </template>
        <template v-slot:item.surveyorzip="{ item }">
          <span class="caption">{{ item.surveyorzip }}</span>
        </template>
        <template v-slot:item.status="{ item }">
          <span class="caption">{{ item.status }}</span>
        </template>
        <!--For last column Drop down menu-->
        <template v-slot:item.Action="{item}">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon background-color="transparent" flat>mdi-view-dashboard</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title @click="actionMethod(item,'Edit Surveyor')">Edit Surveyor</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title @click="actionMethod(item,'Delete Surveyor')">Delete Surveyor</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
      <!---------------------------Delete Dialog---------------------------------------------->
      <v-dialog v-model="deletedialog" max-width="400">
        <v-card>
          <v-card-title class="secondary" height="20px">
            <span class="body-2 white--text">Delete Surveyor</span>
            <v-spacer></v-spacer>
            <v-icon @click="deletedialog = false" class="white--text">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="text-center mt-3">Are you sure to delete surveyor?</v-card-text>
          <v-card-actions>
            <v-btn
              class="primary white--text mr-5"
              text
              @click="deletedialog = false"
              id="Nobutton"
            >No</v-btn>
            <v-btn
              class="secondary white--text"
              text
              @click="surveyorDeteleByid"
              v-model="action"
            >Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-content>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </v-app>
</template>  
<script>
/*importing country names and code json file for phone number */
import CountryJSON from "@/components/Country.json";
import axios from "axios";

export default {
  data: () => ({
    text: "",
    valid1: true,
    valid: true,
    loading4: false,
    loading3: false,
    alertNegetive: false,
    alertPositive: false,
    countryList: [],
    surveyor_id: "",
    countryAdd: "Select Country",
    dialog: false,
    search: "",
    editdialog: false,
    deletedialog: false,
    editSurveyorName: "",
    editCountry: "Select Country",
    editPhoneNumber: "",
    editEmail: "",
    editType: "",
    editCity: "",
    editState: "",
    editZIP: "",
    typeAdd: "",
    departmentAdd: "",
    action: "",
    snack: false,
    path: "Accept",
    max: 30,
    max_Num: 15,

    rules: {
      required: value => !!value || "Required.",
      namerules: value => {
        const pattern =/^([a-zA-Z]+\s)*[a-zA-Z]+$/;
        return pattern.test(value) || "Only alphabets are allowed";
      },
      specialCharecter: value => {
        const pattern = /^\S*$/;
        return pattern.test(value) || "Spaces Not Allowed";
      },
      counter: value => value.length <= 20 || "Max 20 characters",
      counterNumber: value => value.length <= 15 || "Max 15 characters",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail";
      },
      contactNumber: value => {
        const pattern = /^[0-9][0-9]{7,14}$/;
        return pattern.test(value) || "Only Numeric,Min-7 & Max-15 ";
      },
      zipNumber: value => {
        const pattern = /^[0-9][0-9]{4,14}$/;
        return pattern.test(value) || "Only Numeric,Min-5 & Max-15 ";
      }
    },

    timeout: 2000,
    headers: [
      {
        text: "Date",
        align: "start",
        value: "surveyor_createdon",
        class: "grey lighten-2"
      },
      {
        text: "Surveyor",
        value: "serveyorname",

        class: "grey lighten-2"
      },
      {
        text: "Mobile Number",
        value: "mobno",

        class: "grey lighten-2"
      },
      {
        text: "Email",
        value: "serveyoremail",

        class: "grey lighten-2"
      },
      {
        text: "Type",
        value: "surveyortype_id",

        class: "grey lighten-2"
      },
      {
        text: "City",
        value: "surveyorcity",

        class: "grey lighten-2"
      },
      {
        text: "State",
        value: "surveyorstate",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "ZIP",
        value: "surveyorzip",

        class: "grey lighten-2"
      },
      {
        text: "Status",
        value: "status",

        class: "grey lighten-2"
      },
      {
        text: "Action",
        value: "Action",

        class: "grey lighten-2",
        width: "100"
      }
    ],

    /*Action List for last column */
    ActionList: ["Edit Surveyor", "Delete Surveyor"],
    editSurveyorid: "",
    /*For adding new row in the table */
    surveyorTableData: [],

    loader: null,
    editedIndex: -1,
    DateAdd: "",
    editDepartment: "",
    surveyorNameAdd: "",
    mobileNumberAdd: "",
    emailAdd: "",
    SurveytypeAdd: "",
    cityAdd: "",
    stateAdd: "",
    zipAdd: "",
    statusAdd: "",
    surveyorTypes: [],
    departmentlist: [],
    countryName: [],
    tableLoading: false,
    defaultItem: {
      Date: "04/26/2020",
      Surveyor: "",
      Mobile_Number: "",
      Email: "",
      surveyor_type: "",
      City: "",
      State: "",
      ZIP: " ",
      Status: ""
    }
  }),
  /*For Adding new row in table */
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit Item";
    }
  },
  watch: {
    //   dialog (val) {
    //     val || this.close()
    //     /*Filter for country Name in Add button*/
    //     val && val !== this.select && this.querySelections(val)
    //   },
  },

  created() {
    this.getAllSurveyorsByOrgID();
    this.getallApiforAdd();
    this.getCountry();
    //console.log(this.$store.getters.get_orgId);
  },

  methods: {
    /*For Deleting a row */
    getCountry() {
      this.countryName = CountryJSON;

      var contryListDemo = [];

      var row = {};

      var self = this;
      self.countryName.forEach(function(element) {
        row = {
          countryWithCC: element.name + "(" + element.dial_code + ")",
          dial_cc: element.dial_code
        };
        contryListDemo.push(row);
      });

      this.countryList = contryListDemo;
      console.log(this.countryList);
    },
    closeForadd() {
      this.dialog = false;
      this.loading3 = false;
      this.clear();
    },
    async surveyorDeteleByid() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "DeleteSurveryor_surveyorDeteleByid",
        input: {
          surveyorid: this.surveyor_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        console.log(res);
        this.getAllSurveyorsByOrgID();
        this.deletedialog = false;
        this.text = "Deleted Successfully";
        this.alertPositive = true;
      } catch (error) {
        console.log(error.response);
        return error.response;
      }
    },
    /*For edit survey */
    async surveyorUpdate() {
      console.log(this.editDepartment);
      this.loading4 = true;
      if (this.$refs.form1.validate()) {
        if (
          this.editSurveyorName.trim() == "" ||
          this.editCity.trim() == "" ||
          this.editState.trim() == ""
        ) {
          this.loading4 = false;
          this.alertNegetive = true;
          this.text = "No Space Allowed";
        } else {
          var input = {
            api_key: this.$store.getters.get_OrgDetails.org_apikey,
            api_password: this.$store.getters.get_OrgDetails.org_apipassword,
            command: "UpdateSurveyor_surveyorUpdate",
            input: {
              surveyorid: this.editSurveyorid,
              surveyor_orgid: this.$store.getters.get_orgId,
              surveyor_name: this.editSurveyorName,
              surveyor_email: this.editEmail,
              surveyor_cc: 91,
              surveyor_mobilenumber: this.editPhoneNumber,
              surveyor_city: this.editCity,
              surveyor_county: this.editCountry,
              surveyor_state: this.editState,
              surveyor_zip: this.editZIP,
              surveyor_type: this.editType,
              surveyor_status: 1,
              departmentid: this.editDepartment
            }
          };
          try {
            const res = await axios({
              method: "post",
              url: "http://stage.adjustermate.com/PortalServices",
              data: input
            });
            var updateSurveyor = res.data.success;
            console.log("updateSurveyor", updateSurveyor);
            this.loading4 = false;
            this.editdialog = false;
            this.getAllSurveyorsByOrgID();
            this.text = "Updated Successfully";
            this.alertPositive = true;
            this.clear();
          } catch (error) {
            console.log(error.response);
            return error.response;
          }
        }
      } else {
        this.loading = false;
        this.alertNegetive = true;
        this.loading4 = false;
        this.text = "Please Enter Mandatary Fields*";
      }
    },

    actionMethod(item, actionType) {
      console.log(item);
      this.surveyor_id = item.surveyorid;
      if (actionType == "Edit Surveyor") {
        this.getEditDataFlow(item);
        this.editdialog = true;
      }
      if (actionType == "Delete Surveyor") {
        this.getEditDataFlow(item);
        this.deletedialog = true;
      }
    },

    getValueType(surveyor_type_department, type) {
      var typeid;
      if (type == "type") {
        this.surveyorTypes.forEach(function(element) {
          if (surveyor_type_department == element.surveyortype_name) {
            typeid = element.surveyortype_id;
          }
        });
        return typeid;
      }
      if (type == "department") {
        this.department.forEach(function(element) {
          if (element.department_name == surveyor_type_department) {
            typeid = element.department_id;
          }
        });
        return typeid;
      }
    },
    getEditDataFlow(itemArray) {
      (this.editSurveyorid = itemArray.surveyorid),
        (this.editSurveyorName = itemArray.serveyorname),
        (this.editCountry = this.getcountryName(itemArray.surveyorcounty)),
        (this.editPhoneNumber = itemArray.mobno),
        (this.editEmail = itemArray.serveyoremail),
        (this.editType = this.getValueType(itemArray.surveyortype_id, "type")),
        (this.editCity = itemArray.surveyorcity),
        (this.editState = itemArray.surveyorstate),
        (this.editZIP = itemArray.surveyorzip);
      this.editDepartment = itemArray.department_id;
    },
    getcountryName(value) {
      console.log("nnnnnn", value);
      var name;
      this.countryList.forEach(function(element) {
        if (value == element.dial_cc) {
          name = element.dial_cc;
        }
      });

      return name;
    },
    getallApiforAdd() {
      this.getAllSurveyorTypes();
      this.getAllDepartments();
    },

    async getAllDepartments() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "AllDepartments_getAllDepartments",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.departmentlist = res.data.data.data;
        console.log(this.departmentlist);
      } catch (error) {
        console.log(error.response);
        return error.response;
      }
    },

    async getAllSurveyorTypes() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "TypeOfSurveyors_getAllSurveyorTypes",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.surveyorTypes = res.data.data.data;
        //     console.log("surveyorTypes :" + JSON.stringify(this.surveyorTypes));
      } catch (error) {
        return error.response;
      }
    },

    async getAllSurveyorsByOrgID() {
      this.tableLoading = true;
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSurveyors_getAllSurveyorsByOrgID",
        input: {
          surveyor_orgid: this.$store.getters.get_orgId,
          status: 1
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });

        if (res.data.data.success != false) {
          this.tableLoading = false;
          this.surveyorTableData = res.data.data.data;
          var self = this;
          self.surveyorTableData.forEach(function(element) {
            element.surveyor_createdon = element.surveyor_createdon.split(
              " "
            )[0];
          });
          self.surveyorTableData.forEach(function(element) {
            element.surveyor_createdon = self.formatDate(
              element.surveyor_createdon
            );
          });
        } else {
          this.surveyorTableData = [];
          this.tableLoading = false;
          this.text = "No data available";
          this.alertNegetive = true;
        }

        /*Date for first column */
      } catch (error) {
        return error.response;
      }
    },

    clear() {
      this.$refs.form.reset();
    },

    /*For adding new element to the table */
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    validateRegisterField() {
      var valid = false;
      if (
        this.surveyorNameAdd == "" ||
        this.mobileNumberAdd == "" ||
        this.emailAdd == "" ||
        this.cityAdd == "" ||
        this.stateAdd == "" ||
        this.zipAdd == "" ||
        this.statusAdd == ""
      ) {
        valid = false;
      } else {
        valid = true;
      }
      return valid;
    },

    async insertNewSurveyor() {
      this.loading3 = true;
      if (this.$refs.form.validate()) {
        if (
          this.surveyorNameAdd.trim() == "" ||
          this.cityAdd.trim() == "" ||
          this.stateAdd.trim() == ""
        ) {
          this.loading3 = false;
          this.alertNegetive = true;
          this.text = "No Space Allowed";
        } else {
          var input = {
            api_key: this.$store.getters.get_OrgDetails.org_apikey,
            api_password: this.$store.getters.get_OrgDetails.org_apipassword,
            command: "InsertSurveyors_insertNewSurveyor",
            input: {
              surveytitle: null,
              surveydesciption: null,
              surveyor_name: this.surveyorNameAdd,
              surveyor_email: this.emailAdd,
              surveyor_cc: 91,
              surveyor_mobilenumber: this.mobileNumberAdd,
              surveyor_county: this.countryAdd,
              surveyor_city: this.cityAdd,
              surveyor_state: this.stateAdd,
              surveyor_zip: this.zipAdd,
              surveyor_orgid: this.$store.getters.get_orgId,
              surveyor_type: this.typeAdd,
              departmentid: this.departmentAdd
            }
          };
          try {
            const res = await axios({
              method: "post",
              url: "http://stage.adjustermate.com/PortalServices",
              data: input
            });

            if (res.data.data.data == "Email id already in admins exists") {
              this.alertNegetive = true;
              this.text = "Email id already in admins exists";
              this.dialog = false;
            } else if (res.data.data.data == "Email id already exists") {
              this.alertNegetive = true;
              this.text = "Email id already exists";
              this.dialog = false;
            } else if (res.data.data.success == true) {
              this.dialog = false;
              this.text = "Added Successfully";
              this.alertPositive = true;
            } else {
              this.alertNegetive = true;
              this.text = "Error";
              this.dialog = false;
            }
            this.getAllSurveyorsByOrgID();
            this.loading3 = false;
            this.clear();
          } catch (error) {
            return error.response;
          }
        }
      } else {
        this.loading3 = false;
        this.alertNegetive = true;

        this.text = "Please Enter Mandatary Fields*";
      }
    }
  }
  // Register () {
  //     if (this.editedIndex > -1) {
  //       Object.assign(this.Surveyors[this.editedIndex], this.editedItem)
  //     } else {
  //       this.Surveyors.push(this.editedItem)
  //     }
  //     this.close()
  // },
};
</script>

<style scoped>
#Nobutton {
  margin-left: 30% !important;
}
#search {
  width: 100%;
  height: 100px;
  border: 1px solid lightgray;
}
.Searchrow {
  padding: -10px !important;
  margin: -10px 0px -10px -40px !important;
}
.searchbar {
  width: 150px !important;
  font-size: 14px !important;
  display: flex;
  margin-top: -10px;
  margin-left: -10px;
  padding: 10px 0px 0px 10px;
}
.searchTo {
  width: 150px !important;
  font-size: 14px !important;
  display: flex;
  margin-top: -75px;
  margin-left: 150px;
  margin-bottom: -20px;
  padding: 10px 0px 0px 10px;
}
/*style for the button inside the Add dialog Box */
#Register {
  margin-left: 39% !important;
  margin-top: -50px;
}

.v-input__control {
  min-height: 25px !important;
}
/*To Give permisiion to change the height and width of th etext fields.. */
.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
.v-input__slot {
  padding: 0px;
}
</style>